import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/sass/variables.scss'; // Import the variables.scss file here

Vue.use(Vuetify);

export default new Vuetify({
  customVariables: ['@/sass/variables.scss'], // Register your SCSS file here
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#222831',
        secondary: '#00ADB5',
        accent: '#393E46',
        // info: '#f43f5e',
        sidebar: '#1d2228',
        background: '#f4f6f9',
        error: '#E15554',
        success: '#39C08F',
      },
      dark: {
        primary: '#92AFD7',
        secondary: '#E56B70',
        accent: '#C5D1EB',
        // info: '#6D94BC',
        sidebar: '#1e1e1e',
        background: '#383737',
        error: '#E15554',
        success: '#9FF48A',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
  font: 'Nunito',
});
